export function convertDateToString(date?: Date) {
    if (!date) return "";
    return JSON.stringify(date).replaceAll('"', "");
}
